__turbopack_context__.v({
  "topBarWrapper": "TopBar-module-scss-module__VY5StG__topBarWrapper",
});
